import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'upsellDefaultTitle',
  initialState: '',
  reducers: {
    setUpsellDefaultTitle(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setUpsellDefaultTitle } = slice.actions;
export default slice.reducer;
